import EmojiPicker from "emoji-picker-react"; // v4+
import { useState } from "react";

export default function EmojiInput({ emoji, setEmoji }) {
  const [showPicker, setShowPicker] = useState(false);

  const handleEmojiClick = (emojiData) => {
    setEmoji(emojiData.emoji);
    setShowPicker(false);
  };

  return (
    <span className="emoji-input-wrapper" style={{ display: "flex", alignItems: "center", border: "none" }}>
      <span style={{ position: "relative" }}>
        <button
          onClick={(e) => {
            e.preventDefault();
            setShowPicker((val) => !val);
          }}
          className="emoji-button"
        >
          {emoji}
        </button>
        {showPicker && (
          <span style={{ position: "absolute", zIndex: 100 }}>
            <EmojiPicker onEmojiClick={handleEmojiClick} />
          </span>
        )}
      </span>
    </span>
  );
}
